import Belpower from '../assets/Case-Studies-Assets/belpower.jpg';
import BelcoreLogo from '../assets/Case-Studies-Assets/belcore.png';
import Florecers2 from '../assets/Case-Studies-Assets/florecers-2.png';
import Samfren2 from '../assets/Case-Studies-Assets/samfren-2.png';
import Founders2 from '../assets/Case-Studies-Assets/founders-2.png';
import BlackDoveLogo from '../assets/Case-Studies-Assets/black-dove-logo.png';
import Cash2 from '../assets/Case-Studies-Assets/cash-2.jpeg';
import Zzone2 from '../assets/Case-Studies-Assets/zzone-2.jpg';

export const caseStudies = [
  {
    id: 'black-dove',
    title: 'Black Dove International Limited',
    subtitle: 'Corporate Website',
    client: 'Black Dove International Limited',
    industry: 'Oil & Gas / Trading',
    challenge:
      'Black Dove needed a professional corporate website that reflected its position in oil and gas, environmental management, chemical supplies, and general trading — with clear service presentation, company credibility, and a path for commercial enquiries.',
    whatWeDid: [
      'Designed and developed the Black Dove International Limited corporate website',
      'Built home, about, services, and contact pages aligned to the company profile',
      'Structured a full service catalogue across petroleum, environmental, chemical, and trading lines',
      'Integrated Sanity CMS and a contact form for ongoing content and lead capture',
    ],
    technology: ['Next.js', 'TypeScript', 'Tailwind CSS', 'Sanity CMS', 'Resend'],
    result:
      'A live corporate website that presents Black Dove as an indigenous oil, gas, environmental, and trading company — motto: The Peak of Satisfaction.',
    testimonial: null,
    link: 'https://blackdoveinternationallimited.com',
    image: BlackDoveLogo,
    imageFit: 'contain',
  },
  {
    id: 'founders-friday',
    title: "Founder's Friday",
    subtitle: 'Events & Community Platform',
    client: "Founder's Friday",
    industry: 'Community / Events',
    challenge:
      'Founder’s Friday needed a reliable digital home for a recurring founders’ networking series — somewhere people could understand the community, find events, and take the next step without depending on ad-hoc social posts alone.',
    whatWeDid: [
      'Designed and developed the Founder’s Friday website',
      'Structured the site around events, community, and conversion to attendance',
      'Built a clear public presence for founders, innovators, and collaborators',
      'Delivered a mobile-friendly experience for event discovery',
    ],
    technology: ['React', 'Modern web stack', 'Responsive UI'],
    result:
      'A live platform that carries the Founder’s Friday brand, event series, and community online in one place.',
    testimonial: {
      quote:
        "My team and I look forward to more projects with the Belsoft team and we'll definitely recommend them to any organisation looking for an experienced and qualified dev team.",
      attribution: "Founder's Friday",
    },
    link: 'https://www.foundersfriday.co',
    image: Founders2,
  },
  {
    id: 'ordesea',
    title: 'Ordesea Resources Limited',
    subtitle: 'Corporate Digital Presence',
    client: 'Ordesea Resources Limited',
    industry: 'Corporate',
    challenge:
      'Ordesea needed a professional digital presence that reflected the company’s vision and gave stakeholders a clear, credible online experience.',
    whatWeDid: [
      'Designed and developed Ordesea’s digital presence',
      'Aligned the site with the company’s brand and operating story',
      'Delivered a clean, responsive experience for public visitors',
    ],
    technology: ['Web design', 'Frontend development', 'Responsive UI'],
    result:
      'A completed digital presence that matched the client’s vision and gave Ordesea a professional public face online.',
    testimonial: {
      quote:
        'Working with Belsoft Systems was a pleasure. Their team was attentive, efficient, and committed to delivering a top-notch result that aligned with our vision.',
      attribution: 'Ordesea Resources Limited',
    },
    link: 'https://www.ordesea.com/',
    image: '/ordesea.png',
  },
  {
    id: 'belpower',
    title: 'BelPower',
    subtitle: 'Utility Payments Product',
    client: 'Belsoft Systems (product)',
    industry: 'Fintech / Payments',
    challenge:
      'Customers and businesses needed a single, reliable way to handle everyday utility payments — electricity, airtime, data, and cable TV — across web and mobile, without juggling multiple vendors and workflows.',
    whatWeDid: [
      'Designed and built BelPower as a flagship utility payments product',
      'Delivered web, Android, and iOS experiences for the same product',
      'Implemented centralized payments for electricity, airtime, data, and TV renewals',
      'Continue iterating on business-facing utility management tools',
    ],
    technology: ['Web', 'Android', 'iOS', 'Payments platform'],
    result:
      'A live multi-platform product with a growing user base. BelPower is publicly available and demonstrates Belsoft’s ability to ship and operate software, not only client websites.',
    testimonial: null,
    link: 'https://www.belpower.ng/',
    image: Belpower,
  },
  {
    id: 'belcore',
    title: 'BelCore',
    subtitle: 'Workplace Collaboration Platform',
    client: 'Belsoft Systems (product)',
    industry: 'SaaS / Workplace Ops',
    challenge:
      'Companies — especially teams running day-to-day operations from Nigeria and across Africa — were juggling separate tools for people, attendance, chat, meetings, and HR. They needed one role-aware workspace instead of five apps: who is in, what was said, and what is due.',
    whatWeDid: [
      'Designed and built BelCore as Belsoft’s workplace operating system — “the operating system for the company day”',
      'Shipped people directory, GPS attendance with office geofencing, chat (channels, DMs, threads), meetings, projects, leave, and expenses on one login',
      'Separated the marketing site (belcore.io) from the product workspace (app.belcore.io)',
      'Built role-based access so salary and private records stay off the wrong screens',
    ],
    technology: [
      'Next.js',
      'TypeScript',
      'Tailwind CSS',
      'Node.js',
      'Real-time messaging',
    ],
    result:
      'A live multi-module workplace product: public site on belcore.io and the full workspace on app.belcore.io — demonstrating Belsoft’s ability to ship and operate SaaS, not only client websites.',
    testimonial: null,
    link: 'https://belcore.io',
    image: BelcoreLogo,
    imageFit: 'contain',
  },
  {
    id: 'cashpoint',
    title: 'CashPoint NG',
    subtitle: 'Payments Platform',
    client: 'CashPoint',
    industry: 'Fintech / Payments',
    challenge:
      'CashPoint needed a modern payments experience for fast send, pay, and transfer flows — a product that could move money quickly and grow as the platform matured.',
    whatWeDid: [
      'Designed and developed the CashPoint product experience',
      'Built transaction-focused flows for send, pay, and transfer',
      'Delivered a live product surface while further releases continue',
    ],
    technology: ['Web application', 'Payments flows', 'Product UI'],
    result:
      'A live payments product. Public progress is available while additional features continue to ship.',
    testimonial: null,
    link: 'https://www.cashpointng.org/',
    image: Cash2,
  },
  {
    id: 'florecers',
    title: 'Florecers Place',
    subtitle: 'Fashion & Design Retail',
    client: 'Florecers Place',
    industry: 'Hospitality / Retail',
    challenge:
      'Florecers Place needed an online storefront that presented fashion and design work at the same quality as the physical brand — browsing, brand story, and a clear path for customers.',
    whatWeDid: [
      'Designed and developed the Florecers Place website',
      'Built a retail-focused product presentation and browsing experience',
      'Delivered a responsive brand site aligned with the fashion and design offering',
    ],
    technology: ['Web design', 'E-commerce presentation', 'Responsive UI'],
    result:
      'A live fashion and design website that presents the brand and supports customer discovery online.',
    testimonial: null,
    link: 'https://www.florecersplace.com/',
    image: Florecers2,
  },
  {
    id: 'samfren',
    title: 'SAMFREN OJO MEDIA',
    subtitle: 'Production Company Website',
    client: 'SAMFREN OJO MEDIA',
    industry: 'Media / Production',
    challenge:
      'A growing production company needed a digital presence where the work led — storytelling and visual craft first, not a generic agency layout.',
    whatWeDid: [
      'Designed and developed the SAMFREN OJO MEDIA website',
      'Structured the site around portfolio and production storytelling',
      'Delivered a responsive public presence for the production brand',
    ],
    technology: ['Web design', 'Frontend development', 'Responsive UI'],
    result:
      'A live production-company website that puts creative work front and center.',
    testimonial: null,
    link: 'https://www.samfrenojomedia.com/',
    image: Samfren2,
  },
  {
    id: 'eza-ai',
    title: 'EZA AI',
    subtitle: 'Restaurant Operations Platform',
    client: 'EZA AI',
    industry: 'Hospitality / Operations',
    challenge:
      'Restaurants needed better day-to-day operational tools — including ordering and service flows — that improve efficiency without adding friction for staff or guests.',
    whatWeDid: [
      'Designed and built an AI-assisted restaurant operations platform',
      'Focused product flows on operational efficiency and guest experience',
      'Delivered a live product surface for restaurant use',
    ],
    technology: ['Web application', 'AI-assisted product features', 'Operations UI'],
    result:
      'A live restaurant operations product publicly available for demonstration.',
    testimonial: null,
    link: 'https://www.sla.net.ng/',
    image: Zzone2,
  },
];
